.editor {
  display: grid;
  min-width: 0;
  gap: 1.5rem;
}

.permissions {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: var(--spacing-form-fields);

  > * {
    flex-shrink: 0;
  }
}

@media (min-width: 768px) {
  .editor {
    min-height: 0;
    flex: 1;
    grid-template-columns: 16rem minmax(0, 1fr);
    grid-template-rows: minmax(0, 1fr);
  }

  .pane {
    min-height: 0;
    overflow-y: auto;
    overscroll-behavior: contain;
    scrollbar-gutter: stable;
    // Keep focus outlines clear of the scroll edge, as Dialog.Body does.
    margin: -0.375rem;
    padding: 0.375rem;
  }
}
